import { IonCard, IonCardContent, useIonRouter } from '@ionic/react';
import '../../components/ListCard.css';
import {
  LIST_CARD_SUBTITLE_CLASSES,
  LIST_CARD_TITLE_CLASSES,
} from '../../components/listCardStyles';
import { FollowChannelButton } from './FollowChannelButton';

interface ChannelListItemProps {
  id: string;
  name: string;
  description?: string | null;
  viewerIsOwner?: boolean;
  viewerIsFollowing?: boolean;
  /** Route of the channel page; it decides which tab stack the channel opens in. */
  channelPath?: string;
}

// A single channel in a listing (search results, a user's public profile),
// rendered as a tappable card matching the timeline PostCard look. The name is
// the headline; the description sits below it in a smaller, muted font, clamped
// to two lines with an ellipsis. Channels of other users show the follow /
// unfollow button when their follow state is known.
export const ChannelListItem = ({
  id,
  name,
  description,
  viewerIsOwner,
  viewerIsFollowing,
  channelPath = `/app/main/channels/${id}`,
}: ChannelListItemProps) => {
  const ionRouter = useIonRouter();
  const showFollowButton = viewerIsOwner === false && viewerIsFollowing !== undefined;

  const openChannel = () => {
    ionRouter.push(channelPath);
  };

  return (
    <IonCard className="fc-list-card m-0 mb-3 bg-white dark:bg-gray-800" button onClick={openChannel}>
      <IonCardContent className="flex items-center gap-3 py-3">
        <div className="min-w-0 flex-1">
          <h2 className={LIST_CARD_TITLE_CLASSES}>{name}</h2>
          {description && (
            <p className={LIST_CARD_SUBTITLE_CLASSES}>{description}</p>
          )}
        </div>
        {showFollowButton && (
          // Following must not also open the channel.
          <div className="shrink-0" onClick={(event) => event.stopPropagation()}>
            <FollowChannelButton channelId={id} viewerIsFollowing={viewerIsFollowing} />
          </div>
        )}
      </IonCardContent>
    </IonCard>
  );
};
